import type { ForegroundTone } from './types.js';

export function fgTone(tone: ForegroundTone) {
  return `cim-fg-${tone}`;
}
